
  import { Vue, Component, Prop, Watch } from "vue-property-decorator";
  import INSERT_USER_FAVORITE_ONE from "@/apollo/user/InsertUserFavoriteOne.gql";
  import HeartIcon from "@/components/icons/HeartIcon.vue";
  import DELETE_USER_FAVORITE_BY_PK from "@/apollo/user/DeleteUserFavoriteByPk.gql";
  import { User_Favorite } from "@/generated/graphql";
  import { NOTIFICATION } from "@/entities/Events";
  import Message from "@/data/notificationsMessages";
  import { defaultErrorNotificationMessage } from "@/data/errorMessages";

  @Component({
    components: {
      HeartIcon,
    },
  })
  
  export default class ToggleFavorite extends Vue {
    @Prop({ type: String, required: true }) readonly currentUserId!: string;
    @Prop({ type: String, required: true }) readonly contractorUserId!: string;
    @Prop({ type: Array, default: () => [] }) readonly favorites!: User_Favorite[];

    processing: boolean = false;
    favoriteEntryId: string = "";

    @Watch("favorites", { immediate: true })
    onFavoritesChange() {
      this.favoriteEntryId = this.favorites[0]?.id;
    }

    get iconClasses(): Record<string, boolean> {
      return {
        ["icon"]: Boolean(this.favoriteEntryId),
      };
    }

    async toggleFavoriteState(): Promise<void> {
      if (this.processing) {
        return;
      }

      this.processing = true;
      try {
        if (this.favoriteEntryId) {
          await this.removeFromFavorites();
        } else {
          await this.addToFavorites();
        }

        this.$emit("updated");
      } catch (error) {
        this.$eventBus.emit(NOTIFICATION, Message.errorMessage(defaultErrorNotificationMessage));
      } finally {
        this.processing = false;
      }
    }

    async removeFromFavorites(): Promise<any> {
      await this.$apollo.mutate({
        mutation: DELETE_USER_FAVORITE_BY_PK,
        variables: {
          favoriteEntryId: this.favoriteEntryId,
        },
      });

      this.favoriteEntryId = "";
    }

    async addToFavorites(): Promise<any> {
      const result = await this.$apollo.mutate({
        mutation: INSERT_USER_FAVORITE_ONE,
        variables: {
          object: {
            favorited_by_id: this.currentUserId,
            favorited_id: this.contractorUserId!,
          },
          id: this.currentUserId
        },
      });

      this.favoriteEntryId = result.data.insert_user_favorite_one.id;
    }
  }
